import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { useDocument } from '@/context/DocumentContext';
import { WorkflowDocument } from '@/types/workflowDocs';
import {
  DocumentEmailMetadata,
  DocumentMetadata,
  WorkflowRun,
} from '@/types/workflowRuns';
import moment from 'moment';
import React from 'react';

type DocumentsPaneProps = {
  run: WorkflowRun;
};

type FileBadgeProps = {
  doc: WorkflowDocument;
  minimal?: boolean;
  sider?: boolean;
  variant: 'default' | 'secondary' | 'outline';
};

export const FileBadge = ({
  doc,
  minimal = false,
  variant,
}: FileBadgeProps) => {
  const { setDocumentId } = useDocument();
  const docsMetadata: any = {};

  const meta: DocumentMetadata = docsMetadata[doc.document_id];
  const emailMeta: DocumentEmailMetadata = docsMetadata[doc.document_id];

  const openDoc = (docId: string) => {
    setDocumentId(docId);
  };

  const className = `
  text-left truncate cursor-pointer
  ${minimal ? 'text-[10px] max-w-[100px] bg-gray-100 text-gray-800 hover:bg-gray-200' : 'w-full'}
  ${meta ? '' : ''}
  `;

  const title =
    doc.document_name || meta?.original_filename || emailMeta?.filename;

  if (!title) {
    return (
      <Badge className={className}>
        <Skeleton className="h-3 w-3/4 min-w-[50px] bg-gray-300" />
      </Badge>
    );
  }

  return (
    <Badge
      className={className}
      onClick={() => openDoc(doc.document_id)}
      title={title}
      variant={variant}
    >
      {title}
    </Badge>
  );
};

const DocumentsPane = (props: DocumentsPaneProps) => {
  const { run } = props;

  const workflowDocs = run.document_store?.documents || {};
  const docs = Object.values(workflowDocs).sort(
    (a: WorkflowDocument, b: WorkflowDocument) => {
      return moment(b.created_at).diff(moment(a.created_at));
    },
  );

  return (
    <div>
      <p className="text-xs text-gray-700">Available information</p>
      <div className="space-y-3">
        {docs.map((doc: WorkflowDocument) => {
          const docId = doc.document_id;
          return <FileBadge doc={doc} key={docId} variant="default" />;
        })}
      </div>
    </div>
  );
};

export default DocumentsPane;
